// The app's search boxes register here so the shell can focus the visible
// one (Cmd/Ctrl+K) and fly the box between the navbar and the menu pane.

export type SearchBoxRole = "nav" | "menu" | "hero";

export interface SearchBoxEntry {
  box: HTMLElement;
  input: HTMLInputElement;
}

const entries = new Map<SearchBoxRole, SearchBoxEntry>();

export function registerSearchBox(role: SearchBoxRole, entry: SearchBoxEntry | null): void {
  if (entry) entries.set(role, entry);
  else entries.delete(role);
}

export const getSearchBox = (role: SearchBoxRole): SearchBoxEntry | undefined => entries.get(role);

/** Focus the first registered box in `order`; false when none is mounted. */
export function focusSearchBox(order: SearchBoxRole[]): boolean {
  for (const role of order) {
    const entry = entries.get(role);
    if (!entry) continue;
    entry.input.focus();
    entry.input.select();
    return true;
  }
  return false;
}
